import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import {
  betterAuthErrorSchema,
  betterAuthSessionResponseSchema,
} from './better-auth-response.schemas';

const signUpResponseSchema = z.object({
  data: betterAuthSessionResponseSchema.nullish(),
  error: betterAuthErrorSchema.nullish(),
});

export type BetterAuthSignUpResponse = z.output<typeof signUpResponseSchema>;

export class BetterAuthSignUpResponseValidator implements Validator<BetterAuthSignUpResponse> {
  readonly standardSchema = signUpResponseSchema;

  validate(value: unknown): Result<BetterAuthSignUpResponse, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Unexpected sign-up response shape.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
